<template>
  <div class="container" />
</template>


<script>
import {
    mapActions,
    mapGetters
} from "vuex";

export default {
    components: {

    },

    setup() {

    },

    data() {
        return {
            td : this.$route.query.td ?? ''
        };
    },
    computed: {
        ...mapGetters(["isSilentLogin", "user"])

    },

    watch: {
        user: function () {

            if (this.user != 'undefined') {
                this.setUser()
            }

        },
    },

    mounted() {
        if (this.$route.query.td) {

            console.log("silent login")
            this.onSilentLogin()
        } else {
            this.$router.replace({
                name: 'login'
            })
        }
    },

    methods: {
        ...mapActions(["silentLogin"]),
        onSilentLogin() {
            this.silentLogin({
                td: this.$route.query.td
            });
        },

        setUser() {
            let oldUser = JSON.parse(localStorage.getItem('user'))
            if ((oldUser?.user?.user_id != this.user?.user?.user_id) && this.user.proxied_by) {
                let msg = `You are logged in as ${oldUser?.user?.full_name ?? 'user'}. Continue to end this session and access ${this.user?.user?.full_name ?? 'user'}’s account.`
                this.$confirmDialog.show({
                title: "Confirmation",
                text: msg,
                hideCloseBtn: 1,
                onConfirm: () => {
                    localStorage.setItem('user', JSON.stringify(this.user))
                    this.navigateUser()
                },
                onClose: () => {
                    
                }
                });
            } else {
                localStorage.setItem('user', JSON.stringify(this.user))
                this.navigateUser()
            }
        },

        navigateUser(){
            // /quote/detail/5669
            if (this.user.job_type) {
                if (this.user.job_type == 'sar') {
                    this.$router.push({
                        path: `/job/detail/${this.user.job_id}`,
                        query : {flow_type :this.$route.query.flow_type}
                    });
                } 
                else if (this.user.job_type == 'uq') {
                    this.$router.push({
                        path: `/quote/detail/${this.user.job_id}`,
                        query : {flow_type :this.$route.query.flow_type}
                    });
                } 
                else {
                    this.$router.push({
                        path: `/appointment/detail/${this.user.job_id}`,
                        query : {flow_type :this.$route.query.flow_type}
                    });
                }
            } else {
                this.$router.push({
                    path: `/appointment/detail/${this.user.appointment_id}`,
                    query : {flow_type :this.$route.query.flow_type}
                });
            }
        }
    },
};
</script>
